/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

// CODE highlighting theme
// require("prismjs/themes/prism-tomorrow.css")
require("prismjs/themes/prism-okaidia.css")